export const navLink = "robots_economics";
export const name = "Економіка";
